import { LabelValueSet } from "../utility/LabelValueSet";

const CareRecipientClassificationType = Symbol();

export class CareRecipientClassification extends LabelValueSet  {
    [CareRecipientClassificationType]: any;
}

const 外出型 = new CareRecipientClassification("外出型", "外出型");
const 家事支援型 = new CareRecipientClassification("家事支援型", "家事支援型");
const 身体介護型 = new CareRecipientClassification("身体介護型", "身体介護型");
const 排泄支援型 = new CareRecipientClassification("排泄支援型", "排泄支援型");

const mapValueToItem: { [key: string] : CareRecipientClassification} = {
    "外出型": 外出型,
    "家事支援型": 家事支援型,
    "身体介護型": 身体介護型,
    "排泄支援型": 排泄支援型,
};

export const careRecipientClassificationList: CareRecipientClassification[] = [
    外出型,
    家事支援型,
    身体介護型,
    排泄支援型,
];

export const getCareRecipientClassificationFromValue = (value: string): CareRecipientClassification | null => {
    return mapValueToItem[value];
};

export type CareRecipientClassificationJson = {
    careRecipientClassification: string
};
